/**
 * Résolution du tenant slug au runtime.
 *
 * Priorité :
 *  1. VITE_TENANT_SLUG dans .env  → override explicite (dev ou staging forcé)
 *  2. localhost / 127.0.0.1       → fallback "acme-test" + warning console
 *  3. Prod                        → premier segment du hostname
 *                                   (clienta.app.domaine.com → "clienta")
 *
 * Le slug est envoyé en header X-Tenant-ID — le middleware API le résout en UUID.
 */
export function getTenantSlug(): string {
  const override = import.meta.env.VITE_TENANT_SLUG as string | undefined;
  if (override) return override;

  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    console.warn(
      '[campus] VITE_TENANT_SLUG non défini — fallback sur "acme-test".\n' +
      'Ajoutez VITE_TENANT_SLUG=acme-test dans apps/web/.env pour supprimer cet avertissement.',
    );
    return 'acme-test';
  }

  return hostname.split('.')[0]!;
}
